import { Icon, Text, Tooltip } from "@src/straps/base";
import { VerticalExpandPanel } from "./VerticalExpandPanel";
import classNames from "classnames";
import { ClickableDiv } from "@src/straps/utils/ClickableDiv";
import { PropsWithChildren, useEffect, useState } from "react";
import { useIsLeftNavCollapsed } from "./state";
import { IconNames } from "../../icons/Icon/types";

export function LeftNavGroup({
  title,
  iconName,
  active,
  isExpandable,
  children,
}: PropsWithChildren<{
  readonly title: string;
  readonly iconName?: IconNames;
  readonly active?: boolean;
  readonly isExpandable?: boolean;
}>) {
  const isLeftNavCollapsed = useIsLeftNavCollapsed();
  const [isExpanded, setIsExpanded] = useState(false);
  const [hideTooltip, setHideTooltip] = useState(false);
  useEffect(() => {
    if (!isExpandable) {
      setIsExpanded(false);
    }
  }, [isExpandable]);
  const textColor = active ? "accent-1" : "primary";

  return (
    <div>
      <ClickableDiv
        onClick={() => setIsExpanded(!isExpanded)}
        className={classNames(
          "mt-5 flex justify-between overflow-hidden border-b border-b-straps-accent-3 px-3 pb-2.5 uppercase",
          {
            "cursor-pointer": isExpandable,
          }
        )}
      >
        <div
          className={classNames("flex min-w-0", {
            "ml-3.5 h-5 items-center": isLeftNavCollapsed,
          })}
        >
          {iconName && isLeftNavCollapsed && (
            <Icon
              name={iconName}
              size="small"
              color={textColor}
              className={classNames("shrink-0", {
                "mr-2.5": !isLeftNavCollapsed,
              })}
            />
          )}
          {!isLeftNavCollapsed && (
            <Tooltip content={title} enabled={!hideTooltip} fixed align="right">
              <Text
                variant={"sc_u-12-700"}
                className="grow truncate uppercase"
                color={textColor}
                ref={(ref) => {
                  setHideTooltip(ref?.clientWidth === ref?.scrollWidth);
                }}
              >
                {title}
              </Text>
            </Tooltip>
          )}
        </div>
        {isExpandable && !isLeftNavCollapsed && (
          <div className="mr-2.5 flex shrink-0 items-center justify-center outline-straps-hyperlink-hover">
            <Icon
              size="small"
              name={"caret-right"}
              className={classNames("!h-2.5 transition-transform", {
                "rotate-90": isExpanded,
              })}
              color={isExpanded ? "primary" : "secondary"}
            />
          </div>
        )}
      </ClickableDiv>
      <VerticalExpandPanel isOpen={!isExpandable || isExpanded}>
        {children}
      </VerticalExpandPanel>
    </div>
  );
}
